var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlobGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "32.53 44.18 134.98 114.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AEE3C5",
    d: "M55,-50.6C67.3,-42.7,70.6,-21.4,64.6,-6C58.6,9.3,43.3,18.7,31,30.6C18.7,42.5,9.3,56.9,-1.9,58.8C-13,60.6,-26.1,49.9,-38,38C-50,26.1,-60.8,13,-65.3,-4.5C-69.7,-22,-67.8,-43.9,-55.9,-51.8C-43.9,-59.7,-22,-53.6,-0.3,-53.2C21.4,-52.9,42.7,-58.5,55,-50.6Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobGreen);
export default __webpack_public_path__ + "static/media/blob_green.2ca1a1754aaa7c87a532fc7c5a71bc4e.svg";
export { ForwardRef as ReactComponent };